/**
 * Agora network-quality numbers: 0 unknown, 1 excellent, 2 good, 3 poor, 4 bad, 5 very bad,
 * 6 disconnected. The facade keeps the numeric scale so native ports can share wire values.
 */
export const NetworkQuality = {
    Unknown: 0,
    Excellent: 1,
    Good: 2,
    Poor: 3,
    Bad: 4,
    VeryBad: 5,
    Disconnected: 6,
};
/** Runtime list of every event name, useful for feature probes and docs generation. */
export const RTC_EVENT_NAMES = [
    'connection-state-changed',
    'user-joined',
    'user-left',
    'user-published',
    'user-unpublished',
    'user-mute-changed',
    'user-role-changed',
    'track-stats',
    'network-quality',
    'token-privilege-will-expire',
    'token-privilege-did-expire',
    'volume-indicator',
    'audio-effect-finished',
    'data-received',
];
export const systemClock = {
    now: () => Date.now(),
    setTimeout: (handler, delayMs) => setTimeout(handler, delayMs),
    clearTimeout: (handle) => {
        clearTimeout(handle);
    },
    setInterval: (handler, intervalMs) => setInterval(handler, intervalMs),
    clearInterval: (handle) => {
        clearInterval(handle);
    },
};
//# sourceMappingURL=types.js.map